import React from 'react';
import _ from 'lodash';

import C from './Controller';

import Icon from '../../Icon';

import {
  MenusWrap,
  Dropdown,
} from './styled';

const Single = ({
  childUrl,
}) => {
    return (
      <a href={childUrl[0].url}>
        {childUrl[0].name}
      </a>
    )
}

const Multi =  ({
  isOpen, title, childUrl,
  onMouseDown,
}) => {
  return [
    <p key="0">
      {title}
      <Icon name="dropdown-arrow" width="10" height="10" />
    </p>,
    <Dropdown key="1" isOpen={isOpen} length={childUrl.length}>
      {childUrl.map((url, key) => (
        <li key={key}>
          <a onClick={onMouseDown.bind(null, url.url)}>{url.name}</a>
        </li>
      ))}
    </Dropdown>
  ]
}

const MenuComponent = ({
  isOpen, idx, title, childUrl, 
  onMouseDown, onClickMenu, onBlurMenu
}) => {
  const urlLen = childUrl ? childUrl.length : 0;
  if (urlLen <= 0) return null;
  const isMulti = urlLen > 1 ? true : false;
  
  const { pathname } = window.location;
  let isActive = false;

  _.each(childUrl, url => {
    if (url.url === pathname) {
      isActive = true;
    }
  });

  return (
    <MenusWrap
      className={childUrl[0].url === '/admin/logout' ? 'LogoutBtn' : ''}
      isActive={isActive}
      tabIndex={idx}
      onClick={onClickMenu}
      onBlur={onBlurMenu}>

      {isMulti ? (
        <Multi
          title={title}
          isOpen={isOpen}
          childUrl={childUrl}
          onMouseDown={onMouseDown} />
      ) : (
        <Single
          childUrl={childUrl} />
      )}
    </MenusWrap>
  )
}

export default C(MenuComponent);


// WEBPACK FOOTER //
// ./client/components/Header/MenuComponent/index.js